import {
  RETRIEVAL_MODE_ALL,
  RETRIEVAL_MODE_LATEST,
  RetrievalMode
} from '../../services/retrieval-mode-preference/retrieval-mode-preference.service';

export const RETRIEVAL_MODE_HISTORY_LATEST_KEY = 'RETRIEVAL_MODE_HISTORY_LATEST';
export const RETRIEVAL_MODE_HISTORY_ALL_KEY = 'RETRIEVAL_MODE_HISTORY_ALL';

export function normalizeRetrievalMode(value: unknown): RetrievalMode | undefined {
  if (value === RETRIEVAL_MODE_LATEST || value === RETRIEVAL_MODE_ALL) {
    return value;
  }
  return undefined;
}

export function extractRetrievalModeFromHistoryAnswer(answer: unknown): RetrievalMode | undefined {
  if (answer == null) {
    return undefined;
  }

  if (typeof answer === 'string') {
    try {
      const parsed = JSON.parse(answer) as { retrieval_mode?: unknown };
      return normalizeRetrievalMode(parsed?.retrieval_mode);
    } catch {
      return undefined;
    }
  }

  if (typeof answer === 'object' && !Array.isArray(answer)) {
    return normalizeRetrievalMode((answer as { retrieval_mode?: unknown }).retrieval_mode);
  }

  return undefined;
}

export function getRetrievalModeHistoryLabelKey(mode: RetrievalMode | undefined): string | null {
  if (mode === RETRIEVAL_MODE_LATEST) {
    return RETRIEVAL_MODE_HISTORY_LATEST_KEY;
  }
  if (mode === RETRIEVAL_MODE_ALL) {
    return RETRIEVAL_MODE_HISTORY_ALL_KEY;
  }
  return null;
}
